import { useMemo } from "react";
import Table from "src/components/Common/UI/DndTable/Table";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useGetUnit } from "../Units/api/getUnit";

const DescriptionTable = ({unitID, unitType}: DescriptionTableProps) => {
  const getUnitQuery = useGetUnit({unitId: unitID});
  
  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
  ];

  const data = getUnitQuery.data ? [getUnitQuery.data] : [];

  const mainColumnData = [
    {
      columnName: "id",
      columnDisplayName: "ID",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "description",
      columnDisplayName: "Περιγραφή",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "unID",
      columnDisplayName: "Κωδικός Μονάδας",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
  ]

  const extraColumnData = [
    {
      columnName: "sapCode",
      columnDisplayName: "Κωδικός SAP",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "hubType",
      columnDisplayName: "Τύπος Hub",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "comments",
      columnDisplayName: "Σχόλια",
      visible: true,
      columnOrder: 6,
      isDraggable: false,
      columnDataType: "String",
    },
  ]

  const columns = useMemo(() => {
    let columnData = mainColumnData;
    if (unitType !== "Units") {
      columnData = [...mainColumnData, ...extraColumnData];
    }
    console.log("columnData", columnData);
    return convertApiHeaderToReactTableHeader(columnData, dataTypes);
  }, [unitType]);

  return (
    <Table
      columns={columns}
      data={data}
      defaultOrderByKeyFilter={"id"}
      showNumberOfRows={false}
      debugMode={false}
      noDataFoundTitle="No Units yet"
      isChangeOrderOrVisibilityEnable={false}
      hiddenColumnsForUser={['id']}
    />
  )
}

export default DescriptionTable;

interface DescriptionTableProps {
  unitID: number;
  unitType: string;
}